window.backhash = window.location.hash;
window.backurl = window.location.href;
if( window.backhash !== '' && window.backhash !== '#' ){
	window.location.hash = '';
	window.scrollTo( 0, 0 );
}

var 
	Navigation,
	_body,
	_window
;

(function($){

	Navigation = {

		$menu : null,
		$header : null,
		timeout : false,
		$triggers : null,
		targets : {},
		totalTargets : 0,

		init : function(){

			// Body
			if( _body === undefined ){
				_body = $( 'body' );
			} 

			// Window
			if( _window === undefined ){
				_window = $( window );
			}

			this.$menu = $( '#menu .menu' );
			this.$header = false;
			//this.$header = _body.children( 'header' );

			// Initial hash
			if( window.backhash !== '' && window.backhash !== '#' ) {
			    setTimeout(function(){
			        Navigation.scrollTo( window.backhash );
			    }, 1 );
			}

			Navigation.bind();

		},

		clickMenuItem : function( item ){
			Navigation.$triggers.removeClass( 'active' );
			Navigation.$triggers.filter( '[href="'+ this.href +'"]' ).addClass( 'active' );
		},

	    bind : function(){

	    	// Targets
	    	if( Navigation.$menu.length ){

	    		this.$triggers = $( 'a', Navigation.$menu );

	    		if( this.$triggers.length ){

	    			// Trigger click
	    			this.$triggers.on( 'click', function(){
						this.$ = this.$ || $( this );
	    				Navigation.clickMenuItem( this );	    			
	    			});

		    		this.$triggers.each(function(){

		    			this.$ = this.$ || $( this );
		    			if( this.href.indexOf( '#' ) >= 0 ){

		    				if( this.href.indexOf( '#' ) === 0 ){
		    					_id = this.href;
		    				}
		    				else {
		    					_id = '#' + this.href.split( '#' ).pop();
		    				}
		    				
		    				var $target = ( _id === '#' ) ? _body : $( _id );
		    				if( $target.length ){

			    				var _top = $target.offset().top;
			    				Navigation.targets[ _top ] = $target;

			    				Navigation.totalTargets++;

		    				}

		    			
		    			}
		    			
		    		});		    		

		            // Bind scroll
		    		if( Navigation.totalTargets > 0 ){
			            _window.scroll(function(){
			                Navigation.checkScroll();
			            });
			            Navigation.checkScroll();
		    		}

	    		}
	    		
	    	}

	        // Bind clicks
	        _body.on( 'click', 'a', function( e ){

	            this.$ = this.$ || $( this );

	            // There is no href
	            if( this.href === undefined || this.href.indexOf( '#' ) < 0 ) return true;

	            // There is no destiny
	            if( this.href === '#' ){
	                event.preventDefault();
	                return;
	            }

	            // Element ID
	            elemnetID = this.href.split( '#' ).pop();

	            // Links
	            if( elemnetID.indexOf( 'http' ) === 0 ){
	                return true;
	            }

	            // Actual url
	            var $target = $( '#' + elemnetID );
	            if( $target.length ){

	                event.preventDefault();

	                // Prevent default page scroll
	                $target.attr( 'id', '' );
	                window.location.hash = elemnetID;
	                $target.attr( 'id', elemnetID );

	                // Scroll to
	                Navigation.scrollTo( $target );
	            
	            }

	        });

	    },

	    getPageTop : function(){
	    	var top = ( window.pageYOffset || document.documentElement.scrollTop )  - ( document.documentElement.clientTop || 0 );
	    	if( this.$header.length ){
	    		top += this.$header.outerHeight();
	    	}
	    	return  top;
	    },

		getPageHeight : function(){
		    var doc = document;
		    return  Math.max(
		        doc.body.scrollHeight, doc.documentElement.scrollHeight,
		        doc.body.offsetHeight, doc.documentElement.offsetHeight,
		        doc.body.clientHeight, doc.documentElement.clientHeight

		    );
		},

		checkIfBottom : function(){

			var 
				pageHeight = this.getPageHeight(),
				pageTop = ( window.pageYOffset || document.documentElement.scrollTop )  - ( document.documentElement.clientTop || 0 ),
				viweportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
			;

			return pageTop >= ( pageHeight - viweportHeight - 100 );


		},

	    checkScroll : function(){

	    	var 
	    		start = Object.keys( this.targets ).shift(),
	    		top = Navigation.getPageTop(),
	    		_id
	    	;

	    	if( top <= start ){

	    		_id = this.$triggers.first().attr( 'href' ).replace( '#', '' );

	    	}
	    	else if( Navigation.checkIfBottom() ){

	    		_id = this.$triggers.last().attr( 'href' ).replace( '#', '' );

	    	}
	    	else {

		    	$.each( this.targets, function(){
		    		
		    		var pos = this.offset().top;
		    		if( top >= ( pos - start ) ){
		    			_id = this.attr( 'id' );
		    		}
		    	
		    	});

	    	}

	    	this.$triggers.removeClass( 'active' );
	    	this.$triggers.filter( '[href="#'+ _id +'"]' ).addClass( 'active' );

	    },

	    scrollTo : function( selector ){

	        var $target = typeof( selector ) === 'object' ? selector : $( selector );            
	        if( !$target.length ) return;

			var newY;
	        if( $target.attr( 'id' ) === 'inicio' ){
	        	newY = 0;
	        }
	        else {
		        newY = $target.offset().top;
	        }

	        var actualY = _window.scrollTop();
	        var distance = actualY - newY;

	        if( distance < 0 ) distance *= -1;
	        
	        var time = ( 600 - ( distance * 0.1 ) );
	        if( time < 1000 ) time = 1000;
	        
	        var offset = $target.data( 'offset' );
	        if( offset ){

	            try {

	                var 
	                    _json = JSON.parse( offset.split( "'" ).join( '"' ) )
	                    _offset = false,
	                    _vWidth = Navigation.vWidth()
	                ;

	                $.each( _json.breaks, function( _break ){
	                    if( _vWidth <= _break ){
	                        _offset = parseInt( this );
	                        return false;
	                    }
	                });

	                offset = ( !_offset ) ? parseInt( _json.initial ) : _offset;

	            }
	            catch( e ){
	                var _offset = parseInt( offset );
	                offset = _offset > 0 ? _offset : 0;
	            }

	        }
	        else {
	            offset = 0;
	        }

	        if( this.$header ){
	        	offset += this.$header.outerHeight();
	        }

	        $( 'html, body' ).animate({
	            scrollTop: ( newY - ( offset ) )
	        }, time );      

	    },

	    vWidth : function vWidth(){
	        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
		
	};

	$(function(){
		Navigation.init();
	});

})(jQuery);
